import styled from 'styled-components';
import { COLORS } from '../../../constants/radar';

// Engagement model | People affected | Measured?
const GRID_COLUMNS = '2.4fr 1.2fr 1.4fr';

export const FiltersBar = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  align-items: center;
  padding: 16px 0;
  border-bottom: 1px solid #e0e0e0;
  margin-bottom: 20px;
`;

export const GridHeader = styled.div`
  display: grid;
  grid-template-columns: ${GRID_COLUMNS};
  gap: 20px;
  align-items: center;
  padding: 8px 16px;
  border-bottom: 2px solid #e2e8f0;

  span {
    font-size: 11px;
    color: #64748B;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    font-weight: 600;
    white-space: nowrap;

    &.num {
      text-align: right;
    }

    &.help {
      cursor: help;
      text-decoration: underline dotted #CBD5E1;
      text-underline-offset: 3px;
    }
  }
`;

export const ModelRow = styled.div`
  display: grid;
  grid-template-columns: ${GRID_COLUMNS};
  gap: 20px;
  align-items: center;
  padding: 10px 16px;
  border-bottom: 1px solid #f1f5f9;

  &:hover {
    background-color: #f8fafc;
  }

  .model {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 14px;
    font-weight: 600;
    color: ${COLORS.PRIMARY};
    min-width: 0;
  }

  .code {
    font-size: 11px;
    font-weight: 600;
    color: #64748B;
    background: #F1F5F9;
    border-radius: 4px;
    padding: 1px 6px;
    letter-spacing: 0.3px;
  }

  .num {
    text-align: right;
    font-size: 14px;
    color: #334155;
    font-variant-numeric: tabular-nums;

    &.muted {
      color: #94A3B8;
    }
  }

  /* An excluded row reads as "out" at a glance — the switch is the control,
     the tint is the state. */
  &.excluded {
    background-color: #FFF7ED;

    .model {
      color: #9A3412;
    }
  }

  /* A row whose switch differs from what is saved */
  &.dirty .model::after {
    content: '•';
    color: #F59E0B;
    font-size: 18px;
    line-height: 0;
  }
`;

export const SwitchCell = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  font-size: 13px;
  color: #475569;
`;

export const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
`;

export const Hint = styled.div`
  font-size: 12px;
  color: #94A3B8;

  &.footer {
    margin-top: 16px;
    padding: 10px 16px;
    border-top: 1px dashed #e2e8f0;
    line-height: 1.6;
  }
`;
